<div class="flex w-full flex-row items-end gap-4">
  <div>
    <span class="mb-1 block text-xs text-greyscale-500">{{
      "travelBoard.status" | transloco
    }}</span>
    <p-selectbutton
      [options]="[
        { label: 'all' | transloco, value: 'all', icon: 'layers' },
        { label: 'draft' | transloco, value: 'draft', icon: 'file-edit' },
        {
          label: 'calculated' | transloco,
          value: 'notDraft',
          icon: 'check-circle',
        },
      ]"
      [(ngModel)]="isDraftFilter"
      size="small"
    >
      <ng-template let-item pTemplate="item">
        <div class="flex items-center gap-1.5">
          <lucide-icon [name]="item.icon" [size]="14" />
          <span>{{ item.label }}</span>
          <span
            [class]="
              isDraftFilter === item.value
                ? 'text-primary-400'
                : 'text-greyscale-400'
            "
            >({{ statusCounts[item.value] }})</span
          >
        </div>
      </ng-template>
    </p-selectbutton>
  </div>

  <div>
    <span class="mb-1 block text-xs text-greyscale-500">{{
      "travelBoards.quickFilters" | transloco
    }}</span>
    <p-selectbutton
      [options]="[
        {
          label: 'travelBoards.needsVerification' | transloco,
          value: 'needsVerification',
          icon: 'sparkles',
        },
        {
          label: 'travelBoards.hasErrors' | transloco,
          value: 'withErrors',
          icon: 'triangle-alert',
        },
      ]"
      [ngModel]="activeQuickFilters()"
      (ngModelChange)="onQuickFiltersChange($event)"
      [multiple]="true"
      size="small"
    >
      <ng-template let-item pTemplate="item">
        <div class="flex items-center gap-1.5">
          <lucide-icon [name]="item.icon" [size]="14" />
          <span>{{ item.label }}</span>
          <span
            [class]="
              activeQuickFilters().includes(item.value)
                ? 'text-primary-400'
                : 'text-greyscale-400'
            "
            >({{ quickFilterCounts[item.value] }})</span
          >
        </div>
      </ng-template>
    </p-selectbutton>
  </div>

  <p-iconfield iconPosition="left" class="w-64">
    <p-inputicon styleClass="pi pi-search" />
    <input
      pInputText
      type="text"
      [(ngModel)]="searchText"
      [placeholder]="'travelBoards.searchTrip' | transloco"
      class="p-inputtext-sm w-full"
    />
    @if (searchText) {
      <p-inputicon
        styleClass="pi pi-times cursor-pointer hover:text-primary-600"
        (click)="clearSearch()"
      />
    }
  </p-iconfield>

  @if (hasActiveFilters) {
    <p-button
      [label]="'travelBoards.resetFilters' | transloco"
      icon="pi pi-filter-slash"
      (click)="resetFilters()"
      size="small"
      [outlined]="true"
    >
    </p-button>
  }
</div>
